




















































export default
  props: ['games']

  computed:
    firstGame: ->
      @games[0]

    otherGames: ->
      @games[1..]
